import React from 'react';
import { Plus } from 'lucide-react';
import { Button, DropdownMenu, DropdownMenuCheckboxItem, DropdownMenuContent, DropdownMenuTrigger, } from '@cargomatic/ui';
/**
 * "Add Filter" dropdown button that shows/hides optional filters.
 */
export function FilterAddButton({ available, active, onToggle, }) {
    const allSelected = available.every((f) => active.includes(f.key));
    if (allSelected)
        return null;
    return (React.createElement(DropdownMenu, null,
        React.createElement(DropdownMenuTrigger, { asChild: true },
            React.createElement(Button, { variant: "outline", size: "sm", className: "h-8 border-dashed font-normal gap-1" },
                React.createElement(Plus, { className: "size-3" }),
                "Add Filter")),
        React.createElement(DropdownMenuContent, { align: "start" }, available.map((filter) => (React.createElement(DropdownMenuCheckboxItem, { key: filter.key, checked: active.includes(filter.key), onCheckedChange: () => onToggle(filter.key), onSelect: (e) => e.preventDefault() }, filter.label))))));
}
